import * as React from "react";
import {FieldWrapper} from "./FieldWrapper";
import {MoneyField} from "../../../../../../Components/Form/MoneyField";

export const CommissionFeeField = ({value, onChange, onDelete}: any) => (
    <FieldWrapper onDelete={onDelete}>
        <MoneyField value={value} onChange={onChange} label="Commission Fee" />
    </FieldWrapper>
);
